import { useState } from 'react'
import { useDispatch } from 'react-redux';
import { networkquestion } from '../../../redux/actions';
import Modal from '../Modal/Modal';
import Button from "../Button/Button";
import './Network.css';
import question from '../../../img/voprositelnyj_znak.svg' 

export default function Network({imei, phone, balans, operator_name}) {
    const dispatch = useDispatch();
    const [action, setAction] = useState('');
    const [modal, setModal] = useState(false);

      const isMinBalans= balans ? (balans<= 50 ? (true) : (false)) : (false);
      function onClickQuestionOpen(value) {
        setAction(value);
        setModal(true);
    }

    async function onClickQuestion() { 
        if (action === 'balanse') {
            await dispatch(networkquestion(imei, 1));
            setModal(false);
            alert(`Команда "Запросить баланс" отправлена`);
        } else if (action === 'number') {
            await dispatch(networkquestion(imei, 2));
            setModal(false);
            alert(`Команда "Запросить номер вставленной sim-карты" отправлена`);
        } 
    }

    return(
        <div className="NetworkCard">
            <div className='NetworkCardHeader'> 
                <h4>Сеть</h4>
            </div>
            <div className="NetworkOperator">
                <span>Оператор: 
                    <span>{operator_name==="default" ? '...' : operator_name}</span>
                    </span>
            </div>
            
            <div className="Balanse">
                   <div>          
                    <span className={isMinBalans && "BalanceMin"}>Баланс: {balans==='*'? ('...') : ( balans+'р')}</span>
                {isMinBalans && 
                <span className="BalanceMin">Внимание!</span>}
                    </div>
                   <button className="Ask-question" onClick={()=>onClickQuestionOpen('balanse')}>
                        <img  src={question} alt="Result" />
                   </button> 
            </div>
            <div className="NamberFone">
                <div>
                    <span>Номер sim-карты: {(phone && phone.length > 0 && phone[0]==='9') ? (8+phone) : ('...')}
                    </span>
                </div>
                <button className="Ask-question" onClick={()=>onClickQuestionOpen('number')}>
                    <img  src={question} alt="Result" />
                </button> 
            </div>

            <Modal key={modal ? 'modal-open' : 'modal-closed'} open={modal}>
                     <div className='modalHeader'>
                     {action === 'balanse' && <h3>Запросить баланс?</h3>}
                     {action === 'number' && <h3>Запросить номер вставленной SIM-карты?</h3>}
                        <svg  onClick={()=>setModal(false)} height="30" viewBox="0 0 200 200" width="30">    
                            <path d="M114,100l49-49a9.9,9.9,0,0,0-14-14L100,86,51,37A9.9,9.9,0,0,0,37,51l49,49L37,149a9.9,9.9,0,0,0,14,14l49-49,49,49a9.9,9.9,0,0,0,14-14Z" />
                        </svg> 
                    </div>   
                    <div className='contentControl-notify'>
                    <div className='notify-body'> 
                        <h4>Внимание.</h4> 
                        {action === 'balanse' && <p>Баланс может быть определен не корректно.</p>}
                        {action === 'number' && <p>Номер вставленной sim-карты может быть определен не корректно.</p>}
                    </div>    
                        <div className='modalButton' >
                            <Button onClick={() => setModal(false)} color="#d2e9d2">Отмена</Button>
                            <Button onClick={()=>onClickQuestion()} color="#4bdd4b">ДА</Button>
                         </div>
                     </div>
                </Modal>
        </div>
    )
}